<!-- Start blog-posts Area -->
<section class="blog-posts-area section-gap">
  <!-- Content of menu 'travail-temporaire' -->
  <div class="single-post" *ngIf="submenu == 'travail-temporaire'">
    <!-- About Start -->
    <section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                            background-size: cover;" id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Travail temporaire
            </h1>
            <!-- <h2 class="text-white font-weight-bold" style="    font-size: 1.5rem !important;">Nous aidons les candidats
              et les entreprises à faire le meilleur
              choix.
            </h2> -->
            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>Travail temporaire</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="container">


    </section>
    <!-- About End -->
    <section class="" style="background:#F0F4F9; padding: 30px 0px;">
      <div class="container">
        <div class="card mb-4 " style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
          <div class="card-body">
            <div class=" rounded-top">

              <p class=" mb-2" style="font-size: 15px !important  ;">Talents plus ETT, à travers son expertise en
                intérim, vous permet d’avoir du personnel dans un temps record sans avoir à
                charge la lourde gestion des formalités administratives y afférentes, tout en garantissant votre
                responsabilité
                sociétale. L’intérim vous aide à faire face à plusieurs situations de durées ponctuelles variant entre 1
                jour et 24
                mois.</p>
              <ul style="font-weight:bold;">
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Expérimentation d’un nouveau poste
                  (processus de recrutement)</li>
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Surcroit d’activités ponctuelles</li>
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Gestion des projets</li>
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Gestion des ouvriers, manœuvres et
                  occasionnels</li>
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Expérimentation d’un nouveau
                  produit/service (équipe pilote)</li>
                <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Emplois à caractère saisonnier et
                  cyclique ne nécessitant pas l’usage permanent d’employés</li>

              </ul>
              <p class=" mb-3" style="font-size: 15px !important  ;">Toutes prestations qui permettent aux
                Organisations d’être compétitives, d’attirer et de fidéliser leurs ressources humaines.</p>
              <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;" href="">Contactez
                nous</a>
            </div>
          </div>
        </div>
      </div>


      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-8 col-lg-8">
            <img style="width:100%; margin-bottom: 30px;" src="assets/img/tempo.jpg">
            <h2 class="customize-title" style="color: #00027d;">Travail temporaire</h2>
            <p style="font-size:20px;">Talents plus ETT, à travers son expertise en intérim, vous permet d’avoir
              du
              personnel dans un temps record sans avoir à charge la lourde gestion des formalités administratives
              y
              afférentes, tout en garantissant votre responsabilité sociétale. L’intérim vous aide à faire face à
              plusieurs situations de durées ponctuelles variant entre 1 jour et 24 mois:</p>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/job-svg.svg"></div>
              <div class="temp-card-text">
                <p>Expérimentation d’un nouveau poste (processus de recrutement)</p>
              </div>
            </div>


            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/activity.svg"></div>
              <div class="temp-card-text">
                <p>Surcroit d’activités ponctuelles</p>
              </div>
            </div>


            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/manager.svg"></div>
              <div class="temp-card-text">
                <p>Gestion des projets</p>
              </div>
            </div>

            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/manager2.svg"></div>
              <div class="temp-card-text">
                <p>Gestion des ouvriers, manœuvres et occasionnels</p>
              </div>
            </div>

            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/product.svg"></div>
              <div class="temp-card-text">
                <p>Expérimentation d’un nouveau produit/service (équipe pilote)</p>
              </div>
            </div>
            <div class="temp-card">
              <div class="temp-card-icon"><img src="assets/img/online.svg"></div>
              <div class="temp-card-text">
                <p>Emplois à caractère saisonnier et cyclique ne nécessitant pas l’usage permanent d’employés</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-6">

            <div class="card-produit0">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">
                  EXTERNALISATION
                </p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Talents Plus ETT, à travers ses prestations en matière d’externalisation, vous permet d’atteindre
                vos
                objectifs par une optimisation des ressources humaines stratégiques, de concentrer vos efforts sur
                le
                management des ressources humaines stratégiques. L’externalisation vous permet :
              </p>
              <ul>
                <li>de réaliser votre souhait de ne pas avoir certaines activités ou fonctions dans votre
                  organigramme
                </li>
                <li>de faire réaliser certaines de vos prestations par une structure spécialisée. Il s’agit
                  souvent
                  des fonctions de support.</li>
              </ul>
              <p></p>
            </div>
            <div class="card-produit2">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">PORTAGE</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Par son produit portage des consultants, Talents Plus ETT se propose d’accompagner dans la
                gestion de
                leurs prestataires et consultants, les Structures en démarche d’accord de siège, les ONG, Projet,
                Organismes Internationaux ayant juste des représentations au pays. Elle leur permet de s’assurer
                que
                ces derniers s’acquittent convenablement de leurs responsabilités vis-à-vis du fisc.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-6">

            <div class="card-produit1">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">MISE A
                  DISPOSITION DE PERSONNEL</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Talents Plus ETT, à travers la mise à disposition de personnel permanent, vous permet de
                capitaliser
                le savoir-faire acquis par une équipe déjà rodée, de faire gagner du temps au manager opérationnel
                (éviter les éternels recommencements), et d’améliorer la qualité de service à travers la
                motivation
                des agents. La mise à disposition de personnel permanent répond à vos besoins de :
              </p>
              <ul>
                <li>disposer de personnel en permanence en attendant d’avoir la possibilité de recruter en interne
                  ou
                  non</li>
                <li>ne pas être obligé d’avoir plusieurs cabinets prestataires pour la rotation des agents ou de
                  changer les agents, le CDD ayant une durée maximum; assurer la gestion administrative d’une
                  partie
                  de son personnel par un prestataire extérieur.</li>
              </ul>
              <p></p>
            </div>
            <div class="card-produit3">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">MISE A
                  DISPOSITION DE PERSONNEL DE MAISON</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Talents Plus ETT dans son souci constant de créer la passion et l’énergie au travail innove avec
                son
                produit « Cœur à l’Ouvrage » pour vous accompagner dans la gestion de votre maison et de vos
                enfants.
                Nous mettons à votre disposition du personnel domestique qualifié et expérimenté.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="ett" style="margin:50px auto;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7 col-lg-7 order-1" style="margin: auto;">
            <div>
              <p class="section-title">Talents Plus Afrique</p>
              <h2 style="color: #00027d;">Le Chef du département</h2>
              <p>Déjà plus de 15 ans que nous nous sommes engagés à vous servir !
                Engagement de la qualité au service d’une plus grande compétitivité de vos entreprises, de vos
                organisations.
                Plus de 15 ans passés à créer de la passion et l’énergie partout où nous intervenons et à viser
                constamment
                l’excellence. <br>
                <br>
              </p>
              <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
              <h3>Alfred BIAOU</h3>
            </div>
          </div>
          <div class="col-12 col-sm-5 col-lg-5 order-2" style="margin: auto;"><img
              style="width: 100%;    border-radius: 10%;margin-top: -8px;" src="assets/img/dg.jpg"></div>
        </div>
      </div>
    </section> -->

  </div>

  <!-- Content of menu 'recrutement' -->
  <div class="single-post" *ngIf="submenu == 'recrutement'">
    <section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                      background-size: cover;" id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Recrutement
            </h1>
            <h2 class="text-white font-weight-bold" style="    font-size: 1.5rem !important;">Nous aidons les candidats
              et les entreprises à faire le meilleur
              choix.
            </h2>
            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>Recrutement</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section style="background:#F0F4F9; padding: 50px 0px;">
      <div class="container">
        <div class="row">
          <div class="Col-12 col-sm-12 col-lg-12">
          </div>
          <div class="col-12 col-sm-8 col-lg-8">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">RECRUTEMENT
                  COMPLET</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Nous assurons l'ensemble du processus de recrutement : publication et collecte des dossiers,
                présélection, Tests, Entretiens, Prise de références... et présentons une short-list final. <br>
                Coaching &amp; suivi du candidat retenu pour une meilleure intégration + 3 autres cv en cas de
                défaillance du candidat retenu après la période d’essaie jusqu'à satisfaction.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">ASSISTANCE
                  TECHNIQUE</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Nous vous accompagnons pour le dépouillement des dossiers collectés pour un processus de recrutement.
                Rassurez-vous, nos consultants sont des experts.

              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">MISE A
                  DISPOSITION DE CV</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Nous vous offrons 3 modes de mises à disposition de CV :
              </p>
              <ul>
                <li>CV plat</li>
                <li>Cv commentés</li>
                <li>les CV commentés avec Tests psychotechniques.</li>
              </ul>
              <p></p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">DECRYPTAGE DE
                  PERSONALITE</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Plus de 55 tests psychotechniques sont administrés en ligne aux candidats. <br> Tests
                psychotechniques en ligne des candidats en partenariat avec un groupe international – CENTRAL TEST
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">CHASSE DE TETE
                </p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Nous débauchons les profils pointus et rares sur le marché et les mettons à la disposition du client
                en un temps rapide. <br> Coaching &amp; suivi du candidat retenu pour une meilleure intégration +
                prise de références.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-8 col-lg-8">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">CVTHEQUE</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Nous vous permettons d'avoir accès à notre CVthèque pour faire votre propre recherche de CV. Cet
                accès est conditionné par le type d'accès auquel vous auriez souscrit. <br>Les autorisations d'accès
                ont une durée de vie d'un mois et ne vous permettent d'avoir accès à un profil spécifique allant de
                "Perles rares"," Cadres" à "Employés et Agents de Maitrise". Vous pouvez consulter les cv de plus de
                50 000 abonnés de notre Cvthèque
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">COACHING DE
                  PREPARATION</p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>Vous aguerrir à affronter les différentes étapes d'un processus de recrutement en tant que candidat.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-lg-4">
            <div class="card-produit">
              <div>
                <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">E-recrutment
                </p>
                <img style="margin-right: 10px;" src="assets/img/line.svg">
              </div>
              <p>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
            <!-- <h2 style="color : #fff;">Pays où nous sommes intervenus</h2> -->
            <h2 class="customize-title" style="color : #fff;">Pays des missions réalisées.</h2>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BENIN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BURKINA-FASO
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CAMEROUN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CENTRAFRIQUE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CÔTE D’IVOIRE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GHANA
            </p>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">

              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE BISSAU
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE CONAKRY
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> HAITI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> KENYA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MALI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MAURITANIE
            </p>
          </div>
          <div class="col-12 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGER
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGERIA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SENEGAL
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SIERRA-LEONE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TCHAD
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TOGO
            </p>
          </div>

        </div>
      </div>
    </section>
    <section
      style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <app-autresites></app-autresites>
      </div>
    </section>
  </div>

  <!-- Content of menu 'formation' -->
  <div class="single-post" *ngIf="submenu == 'formation'">
    <section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                                    background-size: cover;" id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Formation
            </h1>

            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>Formation</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ett" style="margin:50px auto;">
      <div class="container">

      </div>
    </section>
    <section class="container mt-4 mb-4">
      <div class="card" style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-sm-7 col-lg-7 order-1" style="margin: auto;">
              <div>
                <p class="fs-5 fw-medium" style="color: #FF5A00;">Notre approche</p>
                <h6 style="font-size:26px; color: #00027d; font-weight: bold;">Formation <span
                    style="color:#FF5A00;">=</span>
                  Investissement</h6>
                <p>Nous vous offrons des formations adaptées à vos besoins. Nos formations sont délivrées dans des
                  conditions optimales par des professionnels références dans leurs domaines. Nous pouvons vous
                  accompagner en matière de :
                </p>
                <ul style="color: #00027d; font-weight: bold;">
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Système d’analyse et d’identification
                    des besoins de formation</li>
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Système d’évaluation de la formation
                  </li>
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Elaboration de plan de formation</li>
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Audit de la formation</li>
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Elaboration de politique de formation
                  </li>
                  <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Organisation et animation de
                    séminaires : confère plaquette</li>
                </ul>
                <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                  href="">Catalogue
                  de formation</a>
              </div>
            </div>
            <div class="col-12 col-sm-5 col-lg-5 order-2" style="margin: auto;"><img
                style="width: 100%;    border-radius: 10%;" src="assets/img/train.jpg"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="testimonials"
      style="padding: 10px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container p-3">
        <h2 class="customize-title mb-3 text-white" style="text-align: center !important;">Nos certifications et
          agréments</h2>
        <div class="row">
          <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
        align-items: center;">
            <img src="assets/img/interteck.png" alt="">
          </div>
          <div class="col-lg-8  col-12 col-sm-6 ">
            <p class="text-justify text-white"><b>Les prestations de formations de Talents Plus Conseils Bénin ont
                reçu la
                certification qualité ISO
                29993 V 2017 –
                Qualité des organismes de formation.</b>ISO 29993 V 2017 est le gage de qualité d’un référentiel
              rigoureux reconnu à
              l’international. C’est,
              dorénavant, votre
              critère objectif supplémentaire qui justifie votre préférence et votre confiance en la qualité et en
              l’efficacité de nos
              ateliers de formation. Cette certification des services de formation de Talents Plus Conseils est
              délivrée par <b>INTERTEK</b></p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8  col-12 col-sm-6 ">
            <p class="text-justify text-white">Le Cabinet est également habilité comme Centre de Formation
              Professionnelle
              Continue par le MTFP à
              travers la Direction
              Générale de Renforcement des Capacités et de l'Employabilité (DGRCE) et le Fonds de Développement de
              la Formation
              Professionnelle Continue et de l'Apprentissage (FODEFCA).</p>
          </div>
          <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
        align-items: center;">
            <img src="assets/img/part.jpg" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="formation2" style="background:#fff; padding: 50px 0px;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6"><img style="width:100%; border-radius: 10px;"
              src="assets/img/formation2.jpg"></div>

          <div class="col-12 col-sm-6 col-lg-6" style="margin:auto;">
            <h2 class="customize-title" style="color: #00027d;">Type de formation</h2>
            <p>Nous vous offrons différents types de formations:</p>
            <ul>
              <li><span><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Intra-entreprise</span> (ces
                formations se déroulent au sein d’une entreprise, ce qui est
                intéressant lorsque vous avez une équipe à former)</li>

              <li><span><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Inter-entreprises</span> (ces
                formations se deroulent suivant un calendrier bien précis et
                vous pouvez vous inscrire suivant votre convenance. Elles existent en : Internationales | Régionales |
                Locales Bénin | Locales Côte d'Ivoire.</li>

              <li><span><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Individuelle</span> ( vous vous
                inscrivez aux formations dont vous avez besoin à titre
                individuel )</li>
              <li><span><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> E-learning</span> (Se faire former
                depuis son lieu de travail,
                ou son domicile, sans se déplacer.)</li>
              <li><span><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Coaching</span> </li>
            </ul>

            <a href="/contact/benin-tpc" class="btn btn-submit-second">Faire une demande</a>


          </div>

          <div class="col-12 col-sm-6 col-lg-6" style="margin:auto;">
            <hr class="hh2">

            <p style="font-size: 20px; font-weight: bold;">Nos formations sont offertes en partenariat avec le FODEFCA
              au Bénin, le FDFP en Côte d'Ivoire et le FAFPA au Mali.</p>
          </div>

          <div class="col-12 col-sm-6 col-lg-6" style="margin:auto;">
            <hr class="hh2">
            <img width="100%" src="assets/img/part.jpg">
          </div>

        </div>
      </div>
    </section>
    <section class="domaine"
      style="padding: 20px 0px 20px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-5" style="margin: auto;">
            <h2 class="customize-title" style="color: #fff;">Domaines de formation</h2>
            <p style="font-size:20px; color: #fff;">Vous pouvez consulter nos domaines de formations :</p>
          </div>
          <div class="col-6 col-sm-3 col-lg-3" style="margin: auto;">
            <ul>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Banque</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> SGI</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Fonds</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Microfinance</a>
              </li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Audit et
                  comptabilité</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Informatique</a>
              </li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Management et
                  leadership</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Secrétariat</a>
              </li>

            </ul>
          </div>
          <div class="col-6 col-sm-3 col-lg-4" style="margin: auto;">
            <ul>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Gouvernance</a>
              </li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Conduite de
                  véhicule</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Gestion des
                  ressources humaines</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Juridique</a>
              </li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Marketing</a>
              </li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Anglais</a></li>
              <li><img src="assets/img/rh/check.png" width="30" alt=""><a class="list-color"> Autres
                  domaines</a></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section
      style="padding: 20px 0px 20px; background: url('assets/img/back-distinc.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <h2 class="customize-title" style="text-align: center; font-weight: bold; color: #00027D;">Nos certificats</h2>
        <p style="text-align: center; margin-bottom: 50px;">Vous envisagez d’obtenir des certificats de spécialisation
          dans des métiers porteurs d’avenir, <br> vous ambitionnez de devenir incontournable dans votre domaine de
          compétence, vous êtes à la recherche <br> d’une structure de formation pour vous accompagner dans la
          réalisation de vos projets professionnels, <br>
          Rejoignez-nous dans notre vaste programme de certification-métier dans les domaines suivants :
        </p>




        <div class="row mt-5">
          <div class="col-12 col-sm-3 col-lg-6">
            <div class=" client-hover1" style="height: 145px;">
              <h1 class="titre" style="text-align: center; color: ;">Recrutement excellence.</h1>
            </div>
          </div>

          <div class="col-12 col-sm-3 col-lg-6">
            <div class=" client-hover1" style="height: 145px;">
              <h1 class="titre" style="text-align: center; color: ;">Training excellence : ingénierie de la formation
              </h1>

            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-3 col-lg-4">
            <div class=" client-hover1">
              <h1 class="titre" style="text-align: center; color: ;">Performance excellence : développer, optimiser et
                évaluer un système de gestion de performance</h1>

            </div>
          </div>


          <div class="col-12 col-sm-3 col-lg-2">
            <div class=" client-hover1" style="height: 145px;">
              <h1 class="titre" style="text-align: center; color: ;">Formation des formateurs</h1>

            </div>
          </div>
          <div class="col-12 col-sm-3 col-lg-6">
            <div class=" client-hover1" style="height: 145px;">
              <h1 class="titre" style="text-align: center; color: ;">Traitement des salaires et logiciels de paie.
              </h1>
            </div>
          </div>
        </div>
      </div>


    </section>
    <section class="ett" style="margin:20px auto;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-5 col-lg-5 order-1" style="margin: auto;"><img
              style="width: 100%;    border-radius: 10%;margin-top: -84px;" src="assets/img/chefetudes.png"></div>
          <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin: auto; top: 35px;">
            <div>

              <h2 class="customize-title" style="color: #00027d;">Le Chef du département</h2>
              <p style="text-align: justify;">« Créer la passion et l’énergie » au sein de nos entreprises clientes,
                voilà le choix que nous avons
                fait depuis bientôt
                20 années. A cet effet, le cabinet a choisi le volet formation comme un axe majeur. Certifié suivant la
                norme ISO 29993V
                2017, nous ambitionnons de devenir un centre de formation de référence en Afrique et dans le monde.

                Avec une approche orientée réalités et pratiques de chaque entreprise cliente, approche excellemment
                appréciée de tous
                les clients et participants aux formations, le Cabinet a fait le choix de transformer l’Homme de manière
                à contribuer
                abondamment à l’essor des entreprises/organisations et à contribuer activement au développement de
                l’Afrique.

                A travers des formations interentreprises, intra-entreprises et individuelles, le coaching individuel et
                collectif, le
                team building, etc., nous faisons de votre personnel, des collaborateurs engagés et capables d’aller
                au-delà de leurs
                limites.

                Participez à nos formations et nous vous assurons que vous ne serez plus jamais la même personne.

                Participez à nos formations et vous en sortirez transformé et totalement engagé à entrer dans la logique
                du
                développement de votre entreprise, de votre organisation, de votre pays, de l’Afrique et du monde. <br>
                <br>
              </p>
              <p style="font-weight: bold;">Faites-nous confiance !</p>
              <h3 style="font-weight: bold;">Armand CODO</h3>
              <div class="social-footer" style="margin-bottom: 40px;">
                <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                    style="margin-right: 20px;    fill: #FF5A00; "></a>
                <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Content of menu 'conseil-pme-pmi' -->
  <div class="single-post" *ngIf="submenu == 'conseil-pme-pmi'">
    <section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                                          background-size: cover;" id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Conseils PME/PMI
            </h1>
            <!-- <h2 class="text-white font-weight-bold" style="    font-size: 1.5rem !important;">Nous aidons les candidats
                            et les entreprises à faire le meilleur
                            choix.
                          </h2> -->
            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>Conseils PME/PMI</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ett" style="margin:50px auto;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin: auto;">
            <div>

              <p>Nos interventions sont sur mesures et adaptées à vos besoins dans des conditions optimales par des
                experts en accompagnement et conseils (experts financiers, ingénieurs agronomes, experts en
                entrepreneuriat).
              </p>
              <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;" href="">Contactez
                nous</a>
            </div>
          </div>
          <div class="col-12 col-sm-5 col-lg-5 order-1" style="margin: auto;"><img
              style="width: 100%;    border-radius: 10%;" src="assets/img/conseils.jpg"></div>
        </div>
      </div>
    </section>
    <section
      style="padding: 50px 0px 60px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="row justify-content-center">
        <div class="col-lg-7 ">
          <h2 class="customize-title" style="color: #00027d; text-align: center; ">Nous vous accompagnons avec
            professionnalisme en matière de :</h2>
          <p style="text-align: center;">
          </p>
        </div>
      </div>

      <div class="container">
        <div class="row mt-15">
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/diagnostic.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1 class="customize-title">Réalisation de diagnostic global et/ou léger
                </h1>
                <p></p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/coaching.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1 class="customize-title"> Renforcement de capacités et coaching entrepreneurial et managérial
                </h1>
                <!-- <p>Fourniture de matériel, formation, maintenance</p> -->
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/plan.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1 class="customize-title">Elaboration de Plan d’Affaires
                </h1>
                <!-- <p>Fourniture de matériel, formation, maintenance</p> -->
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/bnk.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1> Note d’Information Bancaire
                </h1>
                <!-- <p>Fourniture de matériel, formation, maintenance</p> -->
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/negoce.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1>Recherche de financement (crédit, subventions, etc.)
                </h1>
                <!-- <p>Fourniture de matériel, formation, maintenance</p> -->
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
            <div class="card-product"
              style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #000 100%), url('assets/img/pme/pitch.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;border-radius: 40px;">
              <div class="disposition">
                <h1>Préparation au pitch de projet, de produits, etc.
                </h1>

              </div>
            </div>
          </div>

        </div>


      </div>
    </section>
    <section
      style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
            <!-- <h2 style="color : #fff;">Pays où nous sommes intervenus</h2> -->
            <h2 class="customize-title" style="color : #fff;">Pays des missions réalisées.</h2>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BENIN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BURKINA-FASO
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CAMEROUN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CENTRAFRIQUE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CÔTE D’IVOIRE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GHANA
            </p>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">

              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE BISSAU
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE CONAKRY
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> HAITI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> KENYA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MALI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MAURITANIE
            </p>
          </div>
          <div class="col-12 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGER
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGERIA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SENEGAL
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SIERRA-LEONE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TCHAD
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TOGO
            </p>
          </div>

        </div>
      </div>
    </section>
    <section class="ett" style="margin:50px auto;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin-top: 132px;">
            <div>

              <h2 class="customize-title" style="color: #00027d;">Le Chef du département</h2>
              <p>Déjà plus de 15 ans que nous nous sommes engagés à vous servir !
                Engagement de la qualité au service d’une plus grande compétitivité de vos entreprises, de vos
                organisations.
                Plus de 15 ans passés à créer de la passion et l’énergie partout où nous intervenons et à viser
                constamment
                l’excellence. <br>
                <br>
              </p>
              <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
              <h3>Adaman Isholla ALILOU</h3>
              <div class="social-footer" style="margin-bottom: 40px;">
                <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                    style="margin-right: 20px;    fill: #FF5A00; "></a>
                <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-5 col-lg-5 order-1" style=""><img
              style="width: 100%;    border-radius: 10%;margin-top: -8px;" src="assets/img/madama.png"></div>
        </div>
      </div>
    </section>
  </div>
  <!-- Content of menu 'assistance-rh' -->
  <div class="single-post" *ngIf="submenu == 'assistance-rh'">
    <section class="top-banner">
      <div class="top-banner-img" style="">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Assistance RH / Droit
                Social</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="volet1" style=" background: #F0F4F9; padding: 50px 0px;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h3 style="font-weight: bold; color: #00027D;">Volet 1 : Gestion de la Paie</h3>
            <p>À la fin de chaque fin du mois, à date retenue, le cabinet communiquera l’état des salaires suivi des
              bulletins de paie des agents. Les informations servant d’intrants sont reçues soit par mail et soit par
              appels
              le 15 de chaque mois.</p>
            <div class="row">
              <div class="col-12 col-sm-6">
                <ul>
                  <li>Le paramétrage d’un logiciel et mise à jour périodique ;</li>
                  <li>Le traitement périodique des éléments variables ;</li>
                  <li>La mise à jour des dossiers de paie (diverses régularisations) ;</li>
                  <li>La préparation des salaires ;</li>
                </ul>
              </div>


              <div class="col-12 col-sm-6">
                <ul>
                  <li>L’édition mensuelle des bulletins et du journal de paie ;</li>
                  <li>L’édition des états de règlement (Ordre de paiement, états d’émargement, etc.…) ;</li>
                  <li>L’élaboration des états de déclaration mensuelle CNSS &amp; Impôts.</li>
                </ul>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
    <section class="volet2" style=" background: #fff; padding: 50px 0px;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h3 style="font-weight: bold; color: #00027D;">Volet 2 : Gestion Externalisée des Ressources Humaines.
            </h3>
            <p>La Gestion Administrative des Ressources Humaines consiste à apporter un appui technique en ce qui
              concerne
              le capital humain. Elle passe par :</p>
            <div class="row">
              <div class="col-12 col-sm-6">
                <ul>
                  <li>L’obtention des permis de travail (expatriés) ;</li>
                  <li>L’embauchage et le débauchage des agents à la CNSS ;</li>
                  <li>La mise à jour des dossiers du personnel conformément à la réglementation ;</li>
                  <li>L’élaboration et l’enregistrement des contrats</li>
                  <li>La déclaration des accidents de travail à la CNSS ;</li>
                  <li>Le règlement des conflits survenus entre la société et les agents ;</li>
                  <li>La gestion des congés ;</li>
                  <li>L’élaboration de divers courriers (notification d’embauche, de fin de contrat, de renouvellement
                    de
                    contrat, de congé, d’augmentation de salaire, de nomination, de mobilité …) ;</li>
                  <li>Régler toutes sortes de problèmes que rencontre la société dans la gestion de son personnel ;
                  </li>
                </ul>
              </div>
              <div class="col-12 col-sm-6">
                <ul>
                  <li>Notification des sanctions et des absences ;</li>
                  <li>Gestion des absences et des congés maladie ;</li>
                  <li>Notification de congé de maternité et procédure au niveau de la CNSS pour la prise en charge;
                  </li>
                  <li>La gestion de la culture d’entreprise : valeurs, mission, code d’éthique : une enquête de
                    satisfaction
                    chaque année;</li>
                  <li>Gestion du processus de performance ;</li>
                  <li>Elaboration de plan de formation et de plan de recrutement et leur mise en œuvre ;</li>
                  <li>Elaboration du budget RH .</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="volet3" style=" background: #F0F4F9; padding: 50px 0px;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h3 style="font-weight: bold; color: #00027D;">Volet 3 : Conseils en Droit Social</h3>
            <p>Le conseil en droit social vise à limiter au maximum voire éliminer le risque d'irrégularité, de
              conflit, de procédure... Dans un contexte légal toujours en mouvement, il est vital pour l'entreprise
              d'être assistée dans sa gestion sociale.</p>


          </div>
        </div>
      </div>

    </section>
    <section
      style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
            <!-- <h2 style="color : #fff;">Pays où nous sommes intervenus</h2> -->
            <h2 class="customize-title" style="color : #fff;">Pays des missions réalisées.</h2>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BENIN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BURKINA-FASO
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CAMEROUN
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CENTRAFRIQUE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CÔTE D’IVOIRE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GHANA
            </p>
          </div>
          <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">

              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE BISSAU
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE CONAKRY
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> HAITI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> KENYA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MALI
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MAURITANIE
            </p>
          </div>
          <div class="col-12 col-sm-2 col-lg-2" style="margin: auto;">
            <p style="color: #fff;">
              <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGER
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGERIA
              <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SENEGAL
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SIERRA-LEONE
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TCHAD
              <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TOGO
            </p>
          </div>

        </div>
      </div>
    </section>
    <section
      style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <div class="container">
        <app-autresites></app-autresites>
      </div>
    </section>

  </div>
  <!-- Content of menu 'etudes-rh' -->
  <div class="single-post" *ngIf="submenu == 'etudes-rh'">
    <section class="section-hero overlay inner-page bg-image"
      style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;                                                   background-size: cover;"
      id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">Etudes RH/Générales
            </h1>

            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>Etudes RH/Générales</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="container mt-5">
      <div class="row">
        <div class="col-12 col-sm-7 col-lg-7 order-6" style="margin: auto;">
          <h3 class="customize-title" style="color: #00027d; font-weight: bold; ">Les différents types d’études</h3>
          <div class="row">
            <div class="col-lg-6">
              <ul style="font-weight:bold;">
                <li> <img src="assets/img/rh/check.png" width="40" class="list-check" alt=""> Audit organisationnel
                </li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Bilan des compétences</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Enquête salariale</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Audit social</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Audit des outils et
                  Politiques RH</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <ul style="font-weight:bold;">
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Enquête de satisfaction
                </li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Enquête d’engagement</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Enquête d’engagement</li>
                <li> <img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Système et évaluation des
                  compétences
                </li>
              </ul>
            </div>
          </div>
          <h3 class="customize-title" style="color: #00027d;font-weight: bold">Les principaux outils</h3>
          <p>Le Cabinet Talents Plus Conseils propose de nombreux outils dont les principaux sont :
          <div class="row">
            <div class="col-lg-6">
              <ul style="font-weight:bold;">
                <li> <img src="assets/img/rh/check.png" width="40" class="list-check" alt=""> Convention collective ou
                  accord d’établissement
                </li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Cadre organique</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Plan de carrière</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Plan de formation</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Plan de recrutement</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Livret d’accueil du
                  personnel
                </li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Règlement intérieur</li>

              </ul>
            </div>
            <div class="col-lg-6">
              <ul style="font-weight:bold;">
                <li> <img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Système de gestion des
                  performances</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Politiques et procédures
                  de
                  GRH</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Grille salariale</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Bilan Social</li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Fiche de poste</li>
                <li> <img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Tableau de bord social
                </li>
                <li><img src="assets/img/rh/check.png" width="40" class="list-check" alt="">Statut du personnel/Manuel
                  G.R.H.</li>
              </ul>
            </div>
          </div>

          <a class="btn  rounded-pill py-3 px-5 mb-2" style="background-color: #FF5A00; color: white;"
            href="/contact/benin-tpc">Contactez
            nous</a>

        </div>
        <div class="col-12 col-sm-5 col-lg-5 order-5"><img style="width: 100%; height: 95%;" src="assets/img/men.jpg">
        </div>
      </div>
    </section>
    <section class="container">
      <div class="row">
        <div class="col-12 col-sm-8 col-lg-3">
          <div class="card-produit">
            <div>
              <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">Staffing</p>
              <img style="margin-right: 10px;" src="assets/img/line.svg">
            </div>
            <p>Audit et optimisation de l'effectif.
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-lg-9">
          <div class="card-produit">
            <div>
              <p style="color: #00027D; text-transform: uppercase; font-weight: bold; margin: 0px;">RSE
              </p>
              <img style="margin-right: 10px;" src="assets/img/line.svg">
            </div>
            <p>Talents Plus Conseils s’engage à accompagner les entreprises dans la construction et la mise en œuvre de
              leur démarche de
              Responsabilité
              Sociétale (RSE). Nous cherchons à donner du sens et à engager vos parties prenantes pour une performance
              globale, vers
              un Développement Durable.

            </p>
          </div>
        </div>
      </div>
    </section>
    <section
      style="padding: 20px 0px 20px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; color: #fff;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-lg-12">
            <h2 class="customize-title" style="text-align: center;">Quelques chiffres clés</h2>
            <hr class="hh">
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+1000</h2>
              <p>Bilans de compétences réalisés</p>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+100</h2>
              <p>Enquêtes salariales conduites</p>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+100</h2>
              <p> Grilles salariales élaborées</p>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+30</h2>
              <p>Missions d’audit organisationnel conduites</p>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+1500</h2>
              <p>Fiches de postes rédigés </p>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-lg-2">
            <div class="chiffre">
              <h2 class="customize-title">+10</h2>
              <p>Missions d’enquête de satisfaction conduites</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7 col-lg-7 order-1" style="margin-top: 43px;">
            <div>

              <h2 class="customize-title" style="color: #00027d;">Le Chef du département</h2>
              <p style="text-align: justify;">Les mutations technologiques économiques et financières post-Covid,
                couplées à la mondialisation et à
                l’accentuation de
                la concurrence, créent aujourd’hui des défis nouveaux auxquels les organisations doivent faire face.
                Plus que jamais, l’entreprise doit se réadapter et mettre en place de nouveaux outils afin d’atteindre
                la performance
                qui lui permet de poursuivre son chemin dans un environnement dynamique, incertain et très exigeant.
                Aujourd’hui, l’accent est de plus en plus mis sur l’apport de la fonction Ressources Humaines à la
                performance
                organisationnelle.
                Ainsi, la fonction a vu naitre un paquet d’outils et de pratiques qui ont pour finalité de permettre à
                l’organisation de
                répondre aux enjeux de son environnement global d’exercice.
                Optimiser donc votre gestion des ressources humaines vous permet d’assurer la performance et la
                pérennité de votre
                entreprise ou de votre organisation. Nous sommes à votre disposition pour des offres sur mesure ou vous
                accompagner dans
                vos projets de réorganisation ou de restructuration.
                <br>
                <br>
              </p>
              <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
              <h3 style="font-weight: bold;">Jacques DOSSOUHOUAN</h3>
              <div class="social-footer" style="margin-bottom: 40px;">
                <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                    style="margin-right: 20px;    fill: #FF5A00; "></a>
                <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
              </div>

            </div>
          </div>
          <div class="col-12 col-sm-5 col-lg-5 order-2" style="margin: auto;"><img
              style="width: 100%;    border-radius: 10%;margin-top: -8px;" src="assets/img/mjacques.png"></div>
        </div>
      </div>
    </section>

    <section
      style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
      <section class="confiance">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-10">
              <h2 class="customize-title"
                style="text-align: center; margin-bottom: 50px; font-weight: bold; color: #00027D;">Ils nous font
                confiance</h2>

              <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="row">
                      <div class="col"><img src="assets/img/rh/afgc.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="pnud logo"></div>
                      <div class="col"><img src="assets/img/rh/padme.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="mtn logo"></div>
                      <div class="col"><img src="assets/img/rh/cncb.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="bceao logo"></div>
                      <div class="col"><img src="assets/img/rh/biic.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/unstim.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/abrp.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                    </div>
                    <div class="row mt-5">
                      <div class="col"><img src="assets/img/rh/fagace.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="pnud logo"></div>
                      <div class="col"><img src="assets/img/rh/fecam.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="mtn logo"></div>
                      <div class="col"><img src="assets/img/rh/mtn.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="bceao logo"></div>
                      <div class="col"><img src="assets/img/rh/moov.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/instad.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/alide.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                    </div>
                  </div>
                  <div class="carousel-item ">
                    <div class="row">
                      <div class="col"><img src="assets/img/rh/anpe.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="pnud logo"></div>
                      <div class="col"><img src="assets/img/rh/emau.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="mtn logo"></div>
                      <div class="col"><img src="assets/img/rh/boad.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="bceao logo"></div>
                      <div class="col"><img src="assets/img/rh/apbef.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/fsa.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                      <div class="col"><img src="assets/img/rh/plan.png"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                    </div>
                    <div class="row mt-5">
                      <div class="col"><img src="assets/img/rh/orabnk.jpg"
                          style="height: 100px; width: 128px; object-fit: contain; " alt="pnud logo"></div>

                    </div>
                  </div>

                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </section>
  </div>
  <div class="single-post" *ngIf="submenu == 'sirh'">
    <section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                                      background-size: cover;" id="home-section">
      <div class="container" style="padding: 100px 0px 100px 0px;">
        <div class="row">
          <div class="col-md-10">
            <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">SIRH
            </h1>
            <div class="custom-breadcrumbs">
              <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
              <a style=" color: #FF5A00 " href="#">Nos produits</a> <span class="mx-2 slash">/</span>
              <span class="text-white"><strong>SIRH</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ett" style="margin:50px auto;">
      <div class="container">
        <div class="row">

          <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
              src="assets/img/tgp/desc.png"></div>
          <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
            <h2 class="customize-title" style="color: #00027D;">Description</h2>
            <p style="text-align: justify; ">Le S.I.R.H. est le système d’information
              de gestion des
              ressources humaines
              (RH). La fonction
              Ressources Humaines a une
              double finalité : performance organisationnelle et satisfaction du personnel. Pour y arriver, un système
              d’information
              idoine est requis pour un pilotage approprié. La digitalisation n’est pas un effet de mode, mais un
              puissant moteur de
              croissance de valeur ajoutée des fonctions. <br>
              Une multitude de SIRH existent mais la véritable question est l’adaptation au code du travail béninois
              et leur capacité
              à apporter la valeur ajoutée à la fonction RH ! <br>

            </p>
          </div>
          <div class="col-12 col-sm-6 col-lg-7" style="margin: auto;">
            <h2 class="customize-title" style="color: #00027D;">Talents Gest Paie</h2>
            <p class="mb-2 text-muted " style=" font-weight: bold !important;">Un
              logiciel de paie,
              une solution qui prend
              en compte les
              réalités africaines.
            </p>
            <p style="text-align: justify; color: #00027D; ">
              Le groupe TALENTS PLUS, fort de sa quinzaine d’année dans la Gestion des Ressources Humaines en Afrique, a
              une solution
              pour vous : <b>TALENTS GEST PAIE.</b>
              Après sa première version destinée aux TPME-TPMI et développée en Excel ; TALENTS GEST PAIE passe à une
              version plus
              adaptée aux PME-PMI, Grandes Entreprises et Grandes Industries.
            </p>
            <p style="text-align: justify;">
              Trouvez à travers TALENTS GEST PAIE v.2, toute notre expertise à la Gestion des Ressources Humaines
              notamment :
            </p>
            <ul style="font-weight:bold;">
              <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> La Gestion administrative ; de l’entrée
                jusqu’à la sortie de l’employé</li>
              <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> La Gestion de la Paie</li>
              <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Le
                Tableau de Bord</li>
              <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Le
                suivi fiscal</li>
              <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Le suivi social</li>
            </ul>
            <p>
              TALENTS GEST PAIE V2 est une application client-serveur permettant de centraliser votre base de données
              une certaine
              flexibilité dans l’utilisation. Un simple navigateur vous permet d’accéder à la plateforme et d’opérer.
            </p>
          </div>
          <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
              src="assets/img/home.PNG">
            <div class="card mt-3" style="    border-radius: 27px;background-color: #ff5a00 !important;">

              <div class="card-body">
                <p class="customize-title" style="font-weight: bold; color: white;">
                  Simulation de salaire Net
                </p>
                <p class="text-white ">Calcul du salaire net à partir du brut </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container mt-4 mb-4">
      <div class="card"
        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);background: #fff  !important;">

        <!-- <img src="assets/img/home.PNG" alt=""> -->
        <div class="container-fluid mb-5 p-5" style="background: #00027D;">


          <link rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.css"
            integrity="sha256-NAxhqDvtY0l4xn+YVa6WjAcmd94NNfttjNsDmNatFVc=" crossorigin="anonymous" />

          <section class="section"
            style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="title-box text-center">
                    <!-- <h3 class="title-heading mt-4 text-white">Profitez de notre tarif promotionnel -30% </h3> -->
                    <p class="f-17 mt-3 text-white" style="text-align: justify;">Gestion optimisée des employés - Des
                      alertes pour le suivi des
                      opérations courantes (congés, absences, fin contrat CDD,
                      fin période essai, etc) - Envoi des fiches de paie par mails - Traitement instantané des salaires
                      - Des exportations des
                      états en PDF et en Excel - Sauvegardes journalières - Edition des logs - Edition des états de
                      salaires - Edition des
                      états de charge fiscales - Edition des états de charges sociales - Edition des Etats par
                      entreprise - Edition des états
                      par employés - Fiche individuelle de carrière - Etat de formation par staff - Edition des tableaux
                      de bord RH.
                    </p>
                  </div>
                </div>
              </div>f
              <div class="row">
                <div class="col-lg-4">
                  <div class="pricing-box mt-4 pricing-info pricing">
                    <div class="pricing-badge">
                      <!-- <span class="badge">Bonus</span> -->
                    </div>
                    <!-- <i class="mdi mdi-account-multiple h1 text-primary"></i> 
                     <i class="mdi mdi-account h1"></i> -->
                    <h4 class="f-20" style="text-align: center; ">Simulation de salaire Net
                    </h4>
                    <div class="">
                      <p class="mb-2 f-18">Caractéristiques</p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Client
                          serveur</b>
                      </p>
                      <p class="mb-1"><i
                          class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Multiposte</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Brut au
                          net</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Net au
                          brut</b>
                      </p>
                      <p class="mb-1"><i
                          class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Exportation excel</b>
                      </p>

                    </div>
                    <!-- <div class="pricing-plan ">
                      <h4 class="text-muted" style="text-align: center;"> <span class="plan pl-3 text-dark">0 FCFA
                        </span></h4>
                    </div> -->
                    <div class="" style="display: flex;justify-content: center;">
                      <a href="/nos-produits/sirh#contact" class="btn btn-danger btn-rounded">Testez maintenant</a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="pricing-box mt-4 pricing-warning pricing">

                    <h4 class="f-20 " style="text-align: center;">Talents Gest Paie version 2 </h4>
                    <div class="">
                      <p class="mb-1 f-18">Caractéristiques</p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Client
                          serveur</b>
                      </p>
                      <p class="mb-1"><i
                          class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Multipostes</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Plusieurs
                          types de licence</b>
                      </p>
                      <p class="mb-1"><i
                          class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Pluriannuel</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Groupe
                          Effectif illimité</b>
                      </p>
                    </div>
                    <!-- <div class="pricing-plan ">
                      <h4 class="text-muted"><span class="plan pl-3 text-dark">500 000 F </span></h4>
                    </div> -->
                    <div class="" style="display: flex;justify-content: center;">
                      <a href="/nos-produits/sirh#contact" class="btn btn-danger btn-rounded">Achetez maintenant</a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="pricing-box mt-4 pricing-danger pricing">
                    <!-- <i class="mdi mdi-account h1"></i> -->
                    <h4 class="f-20" style="text-align: center;">Talents Gest Paie version 1</h4>
                    <div class="">
                      <p class="mb-2 f-18">Caractéristiques</p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Sous
                          Microsoft Excel</b>
                      </p>
                      <p class="mb-1"><i
                          class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Monoposte</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success  f-18 mr-2"></i><b>Une seule
                          licence</b>
                      </p>
                      <p class="mb-1"><i class="mdi mdi-checkbox-marked-circle text-success f-18 mr-2"></i><b>Exercice
                          Annualisé</b> </p>
                    </div>
                    <!-- <div class="pricing-plan ">
                      <h4 class="text-muted" style="text-align: center;"> <span class="plan pl-3 text-dark">200 000 F
                        </span></h4>
                    </div> -->
                    <div class="" style="display: flex;justify-content: center;">
                      <a href="/nos-produits/sirh#contact" class="btn btn-danger btn-rounded">Achetez maintenant</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
        <div id="contact"></div>
        <div class="container tarif-contact" style="padding: 0px 200px;">
          <h2 style="margin-bottom:20px; color: #00027D;">Contactez-nous</h2>
          <form id="myForm">
            <div class="row">
              <div class=" col-md-6" style="">
                <label class="form-label">Nom & Prénom(s)<span>*</span></label>
                <input type="text" class="form-control" id="name" formControlName="name"
                  placeholder="Nom & Prénom(s)**">
              </div>
              <div class=" col-md-6" style="">
                <label class="form-label">Nom de l'entreprise<span>*</span></label>
                <input type="text" class="form-control" id="company_name" formControlName="name"
                  placeholder="Nom de l'entreprise**">
              </div>
              <div class=" col-md-6" style="">
                <label class="form-label">Sujet<span>*</span></label>
                <input type="text" class="form-control" id="subject" formControlName="subject" placeholder="Sujet**">
              </div>
              <div class=" col-md-6" style="">
                <label class="form-label">Pays<span>*</span></label>
                <input type="text" class="form-control" id="country" formControlName="country" placeholder="Pays">
              </div>
              <div class=" col-md-6" style="">
                <label class="form-label">Adresse email<span>*</span></label>
                <input type="email" class="form-control" id="email" style="text-transform: lowercase !important;"
                  formControlName="email" placeholder="Email**">
              </div>
              <div class="mb-3 col-md-6">
                <label for="" class="form-label">Choisissez une version du logiciel<span>*</span></label>
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="gender_consultant" formControlName="version">
                  <option selected="">Version*</option>
                  <option value="v1">Talents Gest Paie version 1</option>
                  <option value="v2">Talents Gest Paie version 2</option>
                </select>
              </div>
              <div class=" col-md-12">
                <label for="" class="form-label">Votre message<span>*</span></label>
                <textarea class="form-control" id="task" rows="4" maxlength="300" formControlName="message"
                  placeholder="Message**"></textarea>
              </div>
              <div class=" col-md-12 mt-2" style="">
                <button type="submit" class="btn btn-submit">Envoyer</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>

  </div>
</section>
<!-- End blog-posts Area -->